export default "__VITE_ASSET__4_xZKT$T__"